import { render, staticRenderFns } from "./allCommunes.vue?vue&type=template&id=590fe450&scoped=true"
import script from "./allCommunes.vue?vue&type=script&lang=js"
export * from "./allCommunes.vue?vue&type=script&lang=js"
import style0 from "./allCommunes.vue?vue&type=style&index=0&id=590fe450&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590fe450",
  null
  
)

export default component.exports